// extracted by mini-css-extract-plugin
module.exports = {"highlighted-text":"style_highlighted-text__x_0iC","highlighted-text__bold":"style_highlighted-text__bold__RVbvF"};